/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react/prop-types */
import React from 'react'
import { Button, Modal, Table } from 'react-bootstrap'

type DataSizeDetailsProps = {
    normalizedDataStats: CollectionStats
    rawDataSizeStats: CollectionStats[]
    aggregationDataStats: CollectionStats[]
    show: boolean
    handleClose: () => void
}

const DataSizeDetails: React.FC<DataSizeDetailsProps> = ({
    normalizedDataStats,
    rawDataSizeStats,
    aggregationDataStats,
    show,
    handleClose
}) => {
    // Concatenate all stats into a single list
    const allStats = [normalizedDataStats, ...rawDataSizeStats, ...aggregationDataStats]

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Normalized, Raw and Aggregation Data Stats</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ overflow: 'auto', maxHeight: '400px' }}>
                    {/* @ts-ignore */}
                    <Table striped={true} bordered={true} condensed={true}>
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Count</th>
                                <th>Bytes Used</th>
                                <th>Data Size</th>
                                <th>Index Size</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allStats.map((stats, index) => (
                                <tr key={index}>
                                    <td>
                                        <strong>{stats.type}</strong>
                                    </td>
                                    <td>{stats.count.toLocaleString()}</td>
                                    <td>{stats.bytesUsed.toLocaleString()}</td>
                                    <td>
                                        <strong>{stats.dataSize.toLocaleString()}</strong>
                                    </td>
                                    <td>{stats.indexSize.toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DataSizeDetails
